import { User } from "./user";
import { CommercialDocumentLine } from './commercial-document-line';
import { CommercialDocumentType } from './commercial-document-type';
import { Travel } from './travel';

export class CommercialDocument {
    id:number = 0;
    travel_id: number = 0;
    travel: Travel = new Travel();
    user_id: number = 0;
    user: User = new User();
    document_number: number = null;
    retention: number = 0;
    retention_isr: number = 0;
    iva: number = 0;
    subtotal: number = 0;
    total: number = 0;
    commercial_document_type_id: number = 0;
    commercialDocumentType: CommercialDocumentType = new CommercialDocumentType();
    status: string = 'Activa';
    description: string = null;
    lines: CommercialDocumentLine[] = [];
}
